import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useRefetchHeaderAndMenu } from '../../utils/services/homePageService';
import { httpClient } from '../../api/http/http-client';

interface Props {
  homePage?: boolean;
}

export const useLanguageSwitcher = (props: Props) => {
  const {
    i18n: { language, changeLanguage },
  } = useTranslation();

  const { refetchGetHeaderAndMenu } = useRefetchHeaderAndMenu();

  const lang = localStorage.getItem('i18nextLng');

  const location = useLocation();
  const path = location.pathname.substring(3) + location.search;
  const data = location.state;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const changeLanguageNavLink = async (item: any) => {
    httpClient.setLanguageToHeader(item.value);
    await changeLanguage(item.value);
    if (item.value !== language) await refetchGetHeaderAndMenu();
  };

  return {
    language,
    path,
    data,
    changeLanguage,
    anchorEl,
    handleClose,
    open,
    lang,
    handleClick,
    refetchGetHeaderAndMenu,
    changeLanguageNavLink,
  };
};
